import { makeAutoObservable } from "mobx";
import { Order, OrderSearchParams, OrderStatus } from "../../models/Order";
import { OrderApi } from "../../apis/Order";
import { DateUtil } from "../../utils/DateUtil";

export default class OrderManagementPageModel {
    orders: Order[] = [];
    searchParams: OrderSearchParams = {};
    selectedOrder: Order | null = null;
    loading: boolean = false;

    constructor() {
        makeAutoObservable(this);
    }

    setSearchParams = (params: Partial<OrderSearchParams>) => {
        this.searchParams = { ...this.searchParams, ...params };
    }

    setSelectedOrder = (order: Order | null) => {
        this.selectedOrder = order;
    }

    resetSearchParams = () => {
        this.searchParams = {};
    }

    fetchOrders = async () => {
        this.loading = true;
        try {
            this.orders = await OrderApi.getOrders({
                ...this.searchParams,
                pageNum: 1,
                pageSize: 20
            });
        } finally {
            this.loading = false;
        }
    }

    cancelAndRefund = async (orderId: string, reason: string): Promise<boolean> => {
        return await OrderApi.cancelAndRefund({
            orderId,
            reason
        });
    }

    partialRefund = async (orderId: string, reason: string, amount: number): Promise<boolean> => {
        return await OrderApi.partialRefund({
            orderId,
            reason,
            amount
        });
    }

    // 修改订单费率
    modifyOrderFeeRate = async (orderId: string, feeRate: number): Promise<boolean> => {
        const success = await OrderApi.modifyOrderFeeRate(orderId, feeRate);
        if (success) {
            // 修改成功后刷新订单列表
            await this.fetchOrders();
        }
        return success;
    }

    // 获取状态显示文本
    getStatusText = (status: OrderStatus): string => {
        const statusMap = {
            [OrderStatus.PENDING_PAYMENT]: "待支付",
            [OrderStatus.PAID_PENDING_SERVICE]: "待开启服务",
            [OrderStatus.SERVICE_IN_PROGRESS]: "服务进行中",
            [OrderStatus.PENDING_ACCEPTANCE]: "待验收",
            [OrderStatus.COMPLETED]: "已完成",
            [OrderStatus.CANCELLED]: "已取消"
        };
        return statusMap[status] || "未知状态";
    }

    // 获取规格版本文本
    getVersionText = (version: number): string => {
        return version === 0 ? "体验版" : "标准版";
    }

    // 格式化时间
    formatTime = (time?: string): string => {
        return time ? DateUtil.formatDatetime(time) : "-";
    }
} 